enum HttpMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
}

enum HttpStatusCode {
  ACCEPTED = 202,
  BAD_REQUEST = 400,
  CREATED = 201,
  FORBIDDEN = 403,
  NO_CONTENT = 204,
  NOT_FOUND = 404,
  OK = 200,
  RATE_LIMIT = 429,
  CONFLICT = 409,
  REQUEST_TOO_LARGE = 431,
  INTERNAL_SERVER_ERROR = 500,
}

enum RequestId {
  GET_ACCOUNTS = 'GET_ACCOUNTS',
  GET_CATEGORIES = 'GET_CATEGORIES',
  GET_DEVICE = 'GET_DEVICE',
  GET_DEVICES = 'GET_DEVICES',
  GET_REACH_TEMPLATE = 'GET_REACH_TEMPLATE',
  GET_RECIPIENTS = 'GET_RECIPIENTS',
  GET_TICKET = 'GET_TICKET',
  GET_TICKETS = 'GET_TICKETS',
  GET_ALL_TICKETS_DEVICES = 'GET_ALL_TICKETS_DEVICES',
  GET_USERS = 'GET_USERS',
  GET_PORTAL_PREFERENCES = 'GET_PORTAL_PREFERENCES',
  SUBMIT_BPIT_TICKET = 'SUBMIT_BPIT_TICKET',
  SUBMIT_CUSTOM_TICKET = 'SUBMIT_CUSTOM_TICKET',
  SET_PORTAL_PREFERENCE = 'SET_PORTAL_PREFERENCE',
  GET_USER_PREFERENCES = 'GET_USER_PREFERENCES',
  GET_ACCOUNT_PREFERENCES = 'GET_ACCOUNT_PREFERENCES',
  GET_CSAT_ELIGIBLITY = 'GET_CSAT_ELIGIBLITY',
}

const ACCOUNT_PREFERENCES_URL =
  'https://preferences.ticketing.api.rackspace.com/ticketing/account-preferences/portal-access';

const ACCOUNTS_URL = 'https://internal.ticketing.api.rackspace.com/accounts';

const API_DEFAULT_RETRIES = 3;

const API_MAIL =
  'https://internal.ticketing.api.rackspace.com/surveys/feedback';

const API_PORTAL_PREFERENCES =
  'https://9xqgjbpq41.execute-api.us-west-2.amazonaws.com/v1/Ticketing/';

const API_REQUEST_DEBOUNCE_WAIT = 700; // milliseconds

const API_REQUEST_RETRY_INTERVAL = 5000; // milliseconds

const MAXIMUM_RESOURCES_LIMIT = 500;

const ATTACHMENT_URL =
  'https://internal.ticketing.api.rackspace.com/attachments';

const BPIT_PREFIX = 'https://proxy.api.manage.rackspace.com/bpit';

const CATEGORIES_URL =
  'https://internal.ticketing.api.rackspace.com/categories';

const CLOUD_FILES_URL = 'https://storage101.ord1.clouddrive.com/';

const CONTACT_GROUPS_URL =
  'https://internal.ticketing.api.rackspace.com/contactgroups/query';

const CLOUD_GROUPS_URL =
  'https://internal.ticketing.api.rackspace.com/usergroups';

const CONTACTS_URL =
  'https://internal.ticketing.api.rackspace.com/contacts/query';

const ALL_CONTACTS_URL =
  'https://internal.ticketing.api.rackspace.com/contacts';

const DEVELOPMENT_MODE = 'development';

const ABORT_ERROR_NAME = 'AbortError';

const ATTACHMENT_CLOUD_FILES_URL = BPIT_PREFIX + '/cloudfiles';

const ATTACHMENT_AWS_URL = BPIT_PREFIX + '/files';

const KEVALIN_METRICS_URL =
  'https://api.kevalin.io/v0/collections/{COLLECTION_NAME}/events';

const PROCESS_INSTANCES_URL = BPIT_PREFIX + '/process-instances';

const READYSTATE_DONE = 4;

const RESOURCES_QUERY_URL =
  'https://resources.api.rackspace.com/resources/query';

const RESOURCES_URL = 'https://resources.api.rackspace.com/resources';

const TEMPLATE_CTUI_TAG = 'ctui';

const TEMPLATES_URL = BPIT_PREFIX + '/templates';

const TICKETS_URL = 'https://internal.ticketing.api.rackspace.com/tickets';

const USER_PREFERENCES_URL =
  'https://preferences.ticketing.api.rackspace.com/ticketing/user-preferences/portal-access';

const CSAT_ELIGIBILITY_URL =
  'https://internal.ticketing.api.rackspace.com/surveys/eligibility';

const CSAT_SUBMIT_URL =
  'https://internal.ticketing.api.rackspace.com/surveys/feedbackResponse';

export {
  ACCOUNT_PREFERENCES_URL,
  ACCOUNTS_URL,
  API_DEFAULT_RETRIES,
  API_MAIL,
  API_PORTAL_PREFERENCES,
  API_REQUEST_DEBOUNCE_WAIT,
  API_REQUEST_RETRY_INTERVAL,
  ATTACHMENT_URL,
  ATTACHMENT_AWS_URL,
  ATTACHMENT_CLOUD_FILES_URL,
  CATEGORIES_URL,
  CLOUD_FILES_URL,
  CONTACT_GROUPS_URL,
  CLOUD_GROUPS_URL,
  CONTACTS_URL,
  CSAT_ELIGIBILITY_URL,
  CSAT_SUBMIT_URL,
  ALL_CONTACTS_URL,
  DEVELOPMENT_MODE,
  BPIT_PREFIX,
  HttpMethod,
  HttpStatusCode,
  PROCESS_INSTANCES_URL,
  READYSTATE_DONE,
  RequestId,
  RESOURCES_QUERY_URL,
  RESOURCES_URL,
  TEMPLATE_CTUI_TAG,
  TEMPLATES_URL,
  TICKETS_URL,
  USER_PREFERENCES_URL,
  ABORT_ERROR_NAME,
  KEVALIN_METRICS_URL,
  MAXIMUM_RESOURCES_LIMIT,
};
